<script setup lang="ts">
const store = useStore()
const { shopInformation } = storeToRefs(store)

const phone = `tel:+48${shopInformation.value.shopInformation.phone.replaceAll(' ', '')}`
</script>

<template>
  <div class="bg-black text-white p-2 md:px-4 md:py-2 flex justify-between items-center text-10 sm:text-12 md:text-14 gap-2">
    <div class="flex flex-col md:flex-row md:gap-2 md:items-center">
      <div class="flex items-center">
        <a :href="phone" class="flex items-center text-white mr-2 whitespace-nowrap">
          <i class="icon-phone w-[30px] text-18" />
          <span class="ml-1">{{ shopInformation.shopInformation.phone }}</span>
        </a>
        <span class="mx-2 whitespace-nowrap">{{ shopInformation.shopInformation.workingHours }}</span>
      </div>
      <div class="flex items-center mt-2 md:mt-0">
        <NuxtLink to="/kontakt#form" class="flex items-center text-white">
          <i class="icon-napisz-do-nas w-[30px] text-18 xs:-ml-[5px] xs:scale-[65%]" />
          <span class="xs:ml-[10px] ml-4">Napisz do nas maila</span>
        </NuxtLink>
      </div>
    </div>
    <div class="flex items-center">
      <NuxtLink to="/i/dla-firm" class="flex items-center whitespace-nowrap">
        <i class="icon-oferta-dla-firm w-[30px] text-[18px]" />
        <span class="ml-1">Oferta dla firm</span>
      </NuxtLink>
    </div>
  </div>
</template>
